import styled from 'styled-components'

import Button from '@galo-monitor/web-components/Button'

export const AddButton = styled(Button)`
  margin-left: auto;
`

export const Grid = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
`

export const Header = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`